import { BalanceChart } from "@/components/screens/PlayingScreen/components/AccountOverviewPanel/AcountDetails/components/BalanceChart";
import BankIcon from "@/components/icons/BankIcon";
import React from "react";
import { HistoryEntry } from "@/types/state";
import DefaultContentContainer from "@/components/shared/DefaultContainer/DefaultContentContainer";
import CashIcon from "@/components/icons/CashIcon";
import clsx from "clsx";
import { formatCurrency } from "@/utils/currencyutils";

type Props = {
    accountHistory: HistoryEntry[];
    balance: number;
    type: "cash" | "depot";
    className?: string;
};

const AccountDetails = ({ accountHistory, balance, type }: Props) => {
    const historyEntries = accountHistory.filter((e) => e.change !== 0);
    const chartValues = accountHistory.map((entry) => entry.newValue);

    const formatChange = (change: number): string => {
        const sign = change > 0 ? "+" : "";
        return `${sign}${formatCurrency(change)} €`;
    };
    if (type === "depot") {
        console.log(historyEntries);
    }

    return (
        <DefaultContentContainer className="h-96 relative flex-1 w-full overflow-hidden " shadow={false}>
            <div className="absolute w-full opacity-40 px-4 pt-4 h-24">
                <BalanceChart balances={chartValues} edgeFade={0.5} smoothing={0.6} strokeWidth={1.2} />
            </div>
            <div className="flex flex-col w-full gap-2 z-10 px-4 py-2.5">
                <div className="flex flex-col items-center justify-between gap-2 font-semibold">
                    <div className="w-full flex items-center gap-1">
                        <span>{type === "cash" ? "Cash" : "Depot"}</span>
                        {type === "cash" ? <CashIcon width={16} height={16} /> : <BankIcon width={16} height={16} />}
                    </div>
                    <div className="text-4xl w-full flex items-baseline font-normal">
                        {formatCurrency(balance)} <span className="text-2xl">€</span>
                    </div>
                </div>

                {historyEntries.length > 0 && (
                    <div className="flex flex-col justify-start items-stretch gap-1 self-stretch mt-2">
                        {[...historyEntries]
                            .slice(-3)
                            .reverse()
                            .map((entry, index) => (
                                <div
                                    key={entry.id}
                                    className={clsx(
                                        "flex flex-row items-center justify-between w-full px-2.5 rounded-full bg-white/15 border-2 border-gray-500/15",
                                        index === 1 ? "opacity-75" : index === 2 ? "opacity-50" : "",
                                    )}
                                >
                                    <div className="text-white ">{entry.title}</div>
                                    <div className="flex flex-row items-center gap-1">
                                        {entry.type === "depot" && entry.newValue !== entry.change && (
                                            <span className="text-white text-xs opacity-70">
                                               {((entry.change / (entry.newValue - entry.change)) * 100).toLocaleString("de-DE", { minimumFractionDigits: 1, maximumFractionDigits: 1 })}%
                                            </span>
                                        )}
                                        <span
                                            className={clsx("", entry.change > 0 ? "text-green-400" : "text-red-400")}
                                        >
                                            {formatChange(entry.change)}
                                        </span>
                                    </div>
                                </div>
                            ))}
                    </div>
                )}
            </div>
        </DefaultContentContainer>
    );
};

export default AccountDetails;
